<template>
  <DraggableSlider class="category-slider"
                   padded>
    <template v-if="loading">
      <SwiperSlide v-for="(index) in 24"
                   :key="`loading_${index}`"
                   style="width: max-content;">
        <CategoryAvatar class="category-slider__category-avatar slide"
                        data-test-id="category-slider-slide-placeholder"/>
      </SwiperSlide>
    </template>
    <template v-else>
      <SwiperSlide v-for="item in categories"
                   :key="item.id"
                   class="category-slider__category-avatar slide">
        <CategoryAvatar v-taptic="'selection'"
                        :data-category-id="item.id"
                        :data-category-name="item.name"
                        data-test-id="category-slider-slide"
                        :active="filteredCategories.includes(item.id)"
                        :name="item.name"
                        :thumb="item.thumb"
                        @click="setCategory(item)"/>
      </SwiperSlide>
    </template>
  </DraggableSlider>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { SwiperSlide } from 'swiper/vue'
import CategoryAvatar from './CategoryAvatar.vue'
import DraggableSlider from '@/components/DraggableSlider/DraggableSlider.vue'
import { useMarketplaceStore } from '@/stores/ssr/useMarketplaceStore'
import { storeToRefs } from "pinia"

const marketplaceStore = useMarketplaceStore()
const { categories, filteredCategories } = storeToRefs(marketplaceStore)

const loading = computed(() => categories.value === null)

async function setCategory({ id }) {
  marketplaceStore.toggleFilteredCategory(id)
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins/breakpoints-up.scss";
@import "@/assets/css/mixins/styling.scss";

.category-slider {
  @include lg-up {
    margin: -1rem 0;
  }

  &:deep(.draggable-slider__slider) {
    gap: calc(0.5rem - 4px);
  }

  &__category-avatar {
    &:first-child {
      margin-left: 1rem;

      @include lg-up {
        margin-left: 0;
      }
    }

    &:last-child {
      margin-right: 1rem;

      @include lg-up {
        margin-left: 0;
      }
    }
  }
}

.swiper {
  margin-top: -1rem;
}

:deep(.swiper-wrapper) {
  padding: 1rem 0;
}

.swiper-slide {
  margin-right: calc(.5rem - 4px);
  width: unset;

  &:last-child {
    margin-right: 0;
  }
}
</style>
